

























import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Shared types
import { Color } from '@coldtec/cos-types';

/**
 *  Component that renders the forwarded colors and reflects
 *  and updates the selected color through a v-model binding.
 */
@Component
export default class SystemColors extends Vue {

    @Prop()
    private value!: string | null | undefined;

    @Prop({ type: Array, required: true })
    private colors!: Array<Color>;

    @Prop({ type: Boolean })
    private preview!: boolean;

    /**
     *
     *  Used to emit an `input` event in case a
     *  value (v-model binding) was provided.
     *
     *  @param color The color to select
     *
     */
    private select(color: Color): void {

        if (this.value === undefined) {

            return;

        }

        this.$emit('input', color.guid);

    }

}
